module.exports = __webpack_public_path__ + "static/ebook_desktop_modal-25f963a5b852d68c4e3de23c15b570f1.jpg";